import React from 'react';
import { default as __ } from '../../../utils';
import Title from '../../../components/title';

function PlayTime(props) {
  let { minutes } = props;
  return (
    <section className="owl">
      <Title value="PLAY" vertices={7} label="TIME" />

      <div stat-display="grid">
        <Title
          xs
          label={__.pluralize((minutes / 60).toFixed(0), 'HOUR', 's', true)}
          vertices={14}
          value={(minutes / 60).toFixed(0)}
        />
        <Title xs label={'Minutes'} vertices={14} value={minutes} />
        <Title
          xs
          label={__.pluralize((minutes / 60 / 24).toFixed(1), 'DAY', 's', true)}
          vertices={14}
          value={(minutes / 60 / 24).toFixed(1)}
        />
      </div>
    </section>
  );
}

export default PlayTime;
